export default __webpack_public_path__ + "static/media/img_mine.min.cae89b9e.png";